/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupTakeawayIcon20Solid = forwardRef('FoodDrinkCupTakeawayIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.152 1a2.25 2.25 0 0 0-2.174 1.67L4.624 4H10a.5.5 0 0 1 0 1H3.75a1 1 0 0 0 0 2h12.5a1 1 0 1 0 0-2h-.607l-.621-2.33A2.25 2.25 0 0 0 12.848 1H7.152Z" }),
        React.createElement("path", { d: "M5.077 16.518 4.29 8.5H15.71l-.786 8.018A2.75 2.75 0 0 1 12.186 19H7.814a2.75 2.75 0 0 1-2.737-2.482Z" })));
});
